.invisible-form {
  display: none;
}

.field-container {
  height: calc(4 * var(--spacer));
  margin-bottom: var(--spacer);
}

.container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

gz-chips-generator-input {
  --input-height: 64px;
  --form-field-max-width: 670px;
  --form-field-label-custom-width: 270px;
  --chip-list-width: 674px;
  margin-bottom: calc(3 * var(--spacer));
}
